//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClickOutside from "vue-click-outside";
import CalendarPopoverLoader from "./loaders/calendar-popover-loader.vue";
import CalendarEventInformation from "@Broker/@Modules/util-components/calendar/calendar-event-information.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CalendarPopover",
  directives: {
    ClickOutside
  },
  components: {
    CalendarPopoverLoader,
    CalendarEventInformation
  },
  props: {
    eventClickObj: {
      type: Object,
      default: () => ({})
    },
    eventDetails: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPopover: false
    };
  },
  computed: {
    eventTargetElement() {
      return this.eventClickObj.el || {};
    },
    startTime() {
      var _this$eventClickObj$e;
      return ((_this$eventClickObj$e = this.eventClickObj.event) == null ? void 0 : _this$eventClickObj$e.start) || "";
    },
    endTime() {
      var _this$eventClickObj$e2;
      return ((_this$eventClickObj$e2 = this.eventClickObj.event) == null ? void 0 : _this$eventClickObj$e2.end) || "";
    }
  },
  methods: {
    show() {
      this.showPopover = true;
    },
    hide() {
      this.showPopover = false;
    },
    handleHidden() {
      this.$emit("hidden");
    }
  }
});